export default "__VITE_ASSET__CfHsHvTt__"